// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c2733759","205":"7e7bf4f5","338":"5b174351","388":"075a6fa0","453":"87ad0ea0","600":"66231dfe","692":"4fbea33d","796":"d85aabd1"}[chunkId] + ".chunk.js";
};